module.exports = __webpack_public_path__ + "img/rc.ae5412bb.png";